export default "__VITE_ASSET__a42db816__"